// Platform boundary: photo-library access and the floating panel are iOS-only.
export default function IOSComposerToolsMenuButton() { return null; }
